module.exports = {
      id: "56b893d851bd6f7a9f6c8fc88bbd567cownership-cooperative.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#56b893d851bd6f7a9f6c8fc88bbd567cownership-cooperative.svg",
      toString: function () {
        return this.url;
      }
    }